/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Yakov Gushchin
 * @version 1.17.0
 * @since 1.0.1
 */

import { LOCATION_CHANGE } from 'connected-react-router';
import produce from 'immer';
import { Reducer } from 'redux';

import { SET_HELP_FLAG, SET_HELP_FLAG_FAIL, SET_HELP_FLAG_SUCCESS, SET_HELP_TIP_TEXT } from './headerConstants';
import { HeaderActionsTypes } from './headerTypes';

export interface IHeaderReducer {
    error: string;
    helpFlag: boolean;
    helpTipText?: string;
}

export const initialHeaderState: IHeaderReducer = {
    error: '',
    helpFlag: true,
    helpTipText: '',
};

const headerReducer: Reducer<IHeaderReducer, HeaderActionsTypes> =
    (state = initialHeaderState, action: HeaderActionsTypes) =>
        produce(state, draft => {
            switch (action.type) {
                /*
                *  SET HELP FLAG
                */
                case SET_HELP_FLAG:
                    break;
                case SET_HELP_FLAG_SUCCESS:
                    draft.helpFlag = action.payload;
                    break;
                case SET_HELP_FLAG_FAIL:
                    draft.error = action.payload;
                    break;

                /*
                *  SET HELP TIP TEXT
                */
                case SET_HELP_TIP_TEXT:
                    draft.helpTipText = action.payload;
                    break;
                case LOCATION_CHANGE:
                    draft.helpTipText = '';
                    break;

                default:
                    break;
            }
        });

export default headerReducer;
